/* Product page behaviour. Everything here is an enhancement: with scripts off,
   the variant radios still post the right `id`, the form still submits to
   /cart/add, and the subscribe option stays on one-time purchase. */
(function () {
  'use strict';

  function money(cents, format) {
    var amount = (cents / 100).toFixed(2);
    var withCommas = amount.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    return (format || '${{amount}}')
      .replace(/\{\{\s*amount_no_decimals\s*\}\}/, withCommas.split('.')[0])
      .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/, amount.replace('.', ','))
      .replace(/\{\{\s*amount\s*\}\}/, withCommas);
  }

  function init(root) {
    var jsonEl = root.querySelector('[data-pdp-json]');
    var data = { variants: [], moneyFormat: null };
    try { data = JSON.parse(jsonEl.textContent); } catch (e) {}
    var fmt = data.moneyFormat;
    var formId = root.getAttribute('data-form-id');
    var form = document.getElementById(formId);

    var el = function (sel) { return root.querySelector(sel); };
    var now = el('[data-pdp-now]');
    var was = el('[data-pdp-was]');
    var save = el('[data-pdp-save]');
    var atc = el('[data-pdp-atc]');
    var atcLabel = el('[data-pdp-atc-label]');
    var idInput = el('[data-pdp-id]');
    var stickyPrice = el('[data-pdp-sticky-price]');
    var stickyAtc = el('[data-pdp-sticky-atc]');
    var mainImg = el('.pdp__img');
    var atcText = atcLabel ? atcLabel.textContent.trim() : 'Add to cart';

    function byId(id) {
      for (var i = 0; i < data.variants.length; i++) {
        if (String(data.variants[i].id) === String(id)) return data.variants[i];
      }
      return null;
    }

    function byOptions(values) {
      for (var i = 0; i < data.variants.length; i++) {
        var v = data.variants[i], ok = true;
        for (var j = 0; j < values.length; j++) if (v.options[j] !== values[j]) { ok = false; break; }
        if (ok) return v;
      }
      return null;
    }

    function render(v) {
      if (!v) {
        if (atc) atc.disabled = true;
        if (atcLabel) atcLabel.textContent = 'Unavailable';
        return;
      }
      if (now) now.textContent = money(v.price, fmt);
      var pct = v.compare > v.price ? Math.floor((v.compare - v.price) * 100 / v.compare) : 0;
      if (was) { was.textContent = money(v.compare, fmt); was.hidden = pct === 0; }
      if (save) { save.textContent = 'Save ' + pct + '%'; save.hidden = pct === 0; }
      if (stickyPrice) stickyPrice.textContent = money(v.price, fmt);
      if (idInput) idInput.value = v.id;
      [atc, stickyAtc].forEach(function (b) { if (b) b.disabled = !v.available; });
      if (atcLabel) atcLabel.textContent = v.available ? atcText : 'Sold out';
      if (stickyAtc) stickyAtc.textContent = v.available ? 'Add to cart' : 'Sold out';

      var onetime = el('[data-pdp-onetime-price]');
      if (onetime) onetime.textContent = money(v.price, fmt);
      var onetimeWas = el('[data-pdp-onetime-was]');
      if (onetimeWas) { onetimeWas.textContent = money(v.compare, fmt); onetimeWas.hidden = !(v.compare > v.price); }
      var planWas = el('[data-pdp-plan-was]');
      if (planWas) planWas.textContent = money(v.price, fmt);
      var planPrice = el('[data-pdp-plan-price]');
      var planSelect = el('[data-pdp-plan-select]');
      if (planPrice && v.plans && v.plans.length) {
        var chosen = planSelect ? planSelect.value : null, p = v.plans[0];
        for (var k = 0; k < v.plans.length; k++) if (String(v.plans[k].id) === String(chosen)) p = v.plans[k];
        planPrice.textContent = money(p.price, fmt);
      }

      if (v.image && mainImg) { mainImg.removeAttribute('srcset'); mainImg.src = v.image; }

      if (window.history && history.replaceState) {
        var url = new URL(window.location.href);
        url.searchParams.set('variant', v.id);
        history.replaceState({}, '', url.toString());
      }
    }

    /* single-option products: the cards are the real id radios */
    root.querySelectorAll('[data-pdp-variant]').forEach(function (r) {
      r.addEventListener('change', function () { if (r.checked) render(byId(r.value)); });
    });

    /* multi-option products: selects resolve to a variant, written to the hidden id */
    var selects = root.querySelectorAll('[data-pdp-option]');
    selects.forEach(function (s) {
      s.addEventListener('change', function () {
        render(byOptions(Array.prototype.map.call(selects, function (x) { return x.value; })));
      });
    });

    /* gallery rail */
    root.querySelectorAll('[data-pdp-thumb]').forEach(function (t) {
      t.addEventListener('click', function () {
        if (!mainImg) return;
        mainImg.srcset = t.getAttribute('data-srcset') || '';
        mainImg.src = t.getAttribute('data-src');
        mainImg.alt = t.getAttribute('data-alt') || '';
        root.querySelectorAll('[data-pdp-thumb]').forEach(function (o) { o.classList.toggle('is-active', o === t); });
      });
    });

    /* subscribe vs one-time: the UI radios are not submitted; they write the
       real selling_plan field, which stays empty (one-time) by default */
    var planInput = el('[data-pdp-plan-input]');
    var planSelect = el('[data-pdp-plan-select]');
    function syncPlan() {
      if (!planInput) return;
      var mode = root.querySelector('[data-pdp-plan-mode]:checked');
      planInput.value = mode && mode.value === 'subscribe' && planSelect ? planSelect.value : '';
      var checked = root.querySelector('[data-pdp-variant]:checked');
      render(checked ? byId(checked.value) : byId(idInput && idInput.value));
    }
    root.querySelectorAll('[data-pdp-plan-mode]').forEach(function (r) { r.addEventListener('change', syncPlan); });
    if (planSelect) planSelect.addEventListener('change', function () {
      var sub = root.querySelector('[data-pdp-plan-mode][value="subscribe"]');
      if (sub) sub.checked = true;
      syncPlan();
    });

    /* quantity */
    var qty = el('[data-pdp-qty-input]');
    root.querySelectorAll('[data-pdp-qty]').forEach(function (b) {
      b.addEventListener('click', function () {
        if (!qty) return;
        var n = (parseInt(qty.value, 10) || 1) + parseInt(b.getAttribute('data-pdp-qty'), 10);
        qty.value = n < 1 ? 1 : n;
      });
    });

    /* add to cart without leaving the page; falls back to a normal submit */
    var msg = el('[data-pdp-msg]');
    if (form && window.fetch) {
      form.addEventListener('submit', function (e) {
        e.preventDefault();
        [atc, stickyAtc].forEach(function (b) { if (b) b.setAttribute('aria-busy', 'true'); });
        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Accept': 'application/json' },
          body: new FormData(form)
        })
          .then(function (r) { return r.json().then(function (j) { return { ok: r.ok, body: j }; }); })
          .then(function (res) {
            if (!res.ok) throw new Error(res.body.description || res.body.message || 'Could not add to cart');
            if (msg) msg.hidden = true;
            return fetch('/cart.js').then(function (r) { return r.json(); }).then(function (cart) {
              var count = document.querySelector('[data-cart-count]');
              if (count) count.textContent = cart.item_count;
              var opener = document.querySelector('[data-cart-open]');
              if (opener) opener.click(); else window.location.href = '/cart';
            });
          })
          .catch(function (err) {
            if (msg) { msg.textContent = err.message; msg.hidden = false; }
          })
          .then(function () {
            [atc, stickyAtc].forEach(function (b) { if (b) b.removeAttribute('aria-busy'); });
          });
      });
    }

    /* sticky bar appears once the main button has scrolled out of view */
    var sticky = el('[data-pdp-sticky]');
    if (sticky && atc && 'IntersectionObserver' in window) {
      new IntersectionObserver(function (entries) {
        sticky.hidden = entries[0].isIntersecting || entries[0].boundingClientRect.top > 0;
      }).observe(atc);
    }
  }

  function boot() { document.querySelectorAll('[data-pdp]').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
})();
